module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e63a049"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/Discounts.vue
// module id = 497
// module chunks = 0